import {ArrowLongLeftIcon} from '@heroicons/react/20/solid';
import React, {useEffect, useState} from 'react';
import {withTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import ComboboxComponent from '../../components/Combobox';
import {selectUser} from '../../features/user/userSlice';
import {createItem, getItem, getList, updateItem} from '../../services/service';
import {toast} from "react-toastify";
import ToggleWithLabel from "../../components/ToggleWithLabel";

function AddAccessories({t}) {
    const navigate = useNavigate()
    const {token} = useSelector(selectUser)
    const [name, setName] = useState('')
    const [shortName, setShortName] = useState('')
    const [handleSide, setHandleSide] = useState('')
    const [maxHalfPerimeter, setMaxHalfPerimeter] = useState()
    const [maxHeight, setMaxHeight] = useState()
    const [maxWidth, setMaxWidth] = useState()
    const [maxSash, setMaxSash] = useState()
    const [accessoriesType, setAccessoriesType] = useState([])
    const [accessoriesOpeningType, setAccessoriesOpeningType] = useState([])
    const [accessoryType, setAccessoryType] = useState(null)
    const [accessoryOpeningType, setAccessoryOpeningType] = useState(null)
    const [openingSides, setOpeningSides] = useState([])
    const [openingSide, setOpeningSide] = useState('INWARD')
    const [isDoor, setIsDoor] = useState(false);
    const {id} = useParams()
    useEffect(() => {
        if (id) {
            (async () => {
                let response = await getItem(`${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories/${id}`, token)
                if (response.success) {
                    setName(response.data.name)
                    setShortName(response.data.shortName)
                    setHandleSide(response.data.handleSide)
                    setMaxHalfPerimeter(response.data.maxHalfPerimeter)
                    setMaxHeight(response.data.maxHeight)
                    setMaxWidth(response.data.maxWidth)
                    setMaxSash(response.data.maxSash)
                    setAccessoryType(response.data.accessoriesType)
                    setAccessoryOpeningType(response.data.openingType)
                    setOpeningSide(response.data.openingSide || 'INWARD')
                    setIsDoor(response.data.door)
                }
            })()
        }
        (async () => {
            let response = await getList(`${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories/enum/type`, token)
            if (response.success) {
                let reviewData = response.data.map(item => {
                    return {
                        id: item.id,
                        name: t(`${item.name}`),
                        value: item.name
                    }
                })
                setAccessoriesType(reviewData)
            }
        })();
        (async () => {
            let response = await getList(`${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories/enum/openingtype`, token)
            if (response.success) {
                let reviewData = response.data.map(item => {
                    return {
                        id: item.id,
                        name: t(`${item.name}`),
                        value: item.name
                    }
                })
                setAccessoriesOpeningType(reviewData)
            }
        })();
        (async () => {
            let response = await getList(`${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories/enum/openingside`, token)
            if (response.success) {
                let reviewData = response.data.map(item => {
                    return {
                        id: item.id,
                        name: t(`${item.name}`),
                        value: item.name
                    }
                })
                setOpeningSides(reviewData)
            }
        })();
        return () => {

        };
    }, [])
    const onchangeType = (item) => {
        setAccessoryType(item.value)
    }
    const onchangeOpeningType = (item) => {
        setAccessoryOpeningType(item.value)
    }
    const onchangeOpeningSide = (item) => {
        setOpeningSide(item.value)
    }
    const onSubmit = async (e) => {
        e.preventDefault();
        let data = {
            id: id ? id : null,
            name: e.target['name'].value,
            shortName: e.target['shortName'].value,
            handleSide: e.target['handleSide'].value,
            maxHalfPerimeter: e.target['maxHalfPerimeter'].value,
            maxHeight: e.target['maxHeight'].value,
            maxWidth: e.target['maxWidth'].value,
            maxSash: e.target['maxSash'].value,
            accessoriesType: accessoryType,
            openingType: accessoryOpeningType,
            openingSide: openingSide,
            door: isDoor,

        }
        console.log(data);
        let response = id ? await updateItem(`${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories`, token, data) :
            await createItem(`${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories`, token, data);
        if (response.success) {
            navigate('/furniture')
            toast.success(id ? t('action.edit_success') : t('action.add_success'), {
                position: "bottom-right",
                autoClose: 3000,
                closeOnClick: true,
                className: "add-success"
            });
        }
    }

    return (
        <>
            <div className='w-full mb-8 mt-8'>
                <div className='flex items-center'>
                    <span className='pl-5 pr-5 text-blue-500 ease-in-out hover:text-blue-900 hover:-translate-x-3'>
                        <ArrowLongLeftIcon className='items-center w-8 h-8  hover:cursor-pointer'
                                           onClick={() => navigate(-1)}/>
                    </span>
                    <h3 className="text-lg font-medium leading-6 text-gray-900">{id ? t(`update_furniture`) : t(`new_furniture`)}</h3>
                </div>
            </div>
            <form className="px-5 space-y-6" onSubmit={onSubmit}>
                <div className="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                    <div className="md:grid md:grid-cols-1 md:gap-1">
                        <div className="mt-5 md:col-span-2 md:mt-0">
                            <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                                        {t(`name`)}
                                    </label>
                                    <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        defaultValue={name}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                    />
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                                        {t(`short_name`)}
                                    </label>
                                    <input
                                        type="text"
                                        name="shortName"
                                        id="shortName"
                                        defaultValue={shortName}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                    />
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="handleSide" className="block text-sm font-medium text-gray-700">
                                        {t(`handleSide`)}
                                    </label>
                                    <input
                                        type="number"
                                        name="handleSide"
                                        id="handleSide"
                                        defaultValue={handleSide}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                    />
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="maxHalfPerimeter"
                                           className="block text-sm font-medium text-gray-700">
                                        {t(`maxHalfPerimeter`)}
                                    </label>
                                    <input
                                        type="number"
                                        step={0.001}
                                        name="maxHalfPerimeter"
                                        id="maxHalfPerimeter"
                                        defaultValue={maxHalfPerimeter}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                    />
                                </div>

                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="maxHeight" className="block text-sm font-medium text-gray-700">
                                        {t(`maxHeight`)}
                                    </label>
                                    <input
                                        type="number"
                                        step={0.001}
                                        name="maxHeight"
                                        id="maxHeight"
                                        defaultValue={maxHeight}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                    />
                                </div>


                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="maxWidth" className="block text-sm font-medium text-gray-700">
                                        {t(`maxWidth`)}
                                    </label>
                                    <input
                                        type="number"
                                        step={0.001}
                                        name="maxWidth"
                                        id="maxWidth"
                                        defaultValue={maxWidth}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                    />
                                </div>

                                <div className="col-span-6 sm:col-span-3">
                                    <label htmlFor="maxSash" className="block text-sm font-medium text-gray-700">
                                        {t(`maxSash`)}
                                    </label>
                                    <input
                                        type="number"
                                        name="maxSash"
                                        id="maxSash"
                                        defaultValue={maxSash}
                                        step={0.001}
                                        className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                    />
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                    <ComboboxComponent label={t(`accessoriesType`)} data={accessoriesType}
                                                       item={accessoriesType.find(item => item.value === accessoryType)}
                                                       onChange={onchangeType}/>
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                    <ComboboxComponent label={t(`openingType`)} data={accessoriesOpeningType}
                                                       item={accessoriesOpeningType.find(item => item.value === accessoryOpeningType)}
                                                       onChange={onchangeOpeningType}/>
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                    <ComboboxComponent label={t(`openingSide`)} data={openingSides}
                                                       item={openingSides.find(item => item.value === openingSide)}
                                                       onChange={onchangeOpeningSide}/>
                                </div>
                                <div className="col-span-6 sm:col-span-3 pt-10">
                                    <ToggleWithLabel
                                        label={t('is_door')}
                                        enabled={isDoor}
                                        setEnabled={setIsDoor}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-end">
                    <button
                        onClick={() => navigate(-1)}
                        type="button"
                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                        {t('cancel')}
                    </button>
                    <button
                        type="submit"
                        className="inline-flex justify-center px-4 py-2 ml-3 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                        {t('save')}
                    </button>
                </div>
            </form>
        </>
    )
}

export default withTranslation()(AddAccessories)
